
<div id="sandhub-workarea">
  <div class="title-bar-area">
    <div class="title-area">{{title}}</div>
  </div>
</div>
<div class="smartbank-item-container">
  <!--<div class="smartbank-item-header sectionLeftBorder">-->

    <!--<div [ngStyle]="{'color':smartBankColour}" class="smartbank-item-header-text smartbank-tipoftheweek-header-text">
      IDEA Word of the Week
    </div>-->
  <!--</div>-->
  <div class="smartbank-item-items">
    <div class="smartbank-item-item">
      <div class="formSection-a sectionLeftBorder">
        <div class="smartbank-item-row">
          <div class="smartbank-form-label">
            <input style="min-width: 100px !important; background-color: #ff8a26;" id="tUpdate" type="button" class="btn btn-default" value="Create New" (click)="gotoCreateWordOfTheWeek()" />
          </div>
        </div>
        <div>
          <kendo-grid [data]="wordOfTheWeekList">
            <kendo-grid-column field="startDate" title="Start Date" [width]="100">
              <ng-template kendoGridCellTemplate let-wordItem>
                <span (click)="gotoEditWordOfTheWeek(wordItem)">{{wordItem.startDateModified}}</span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="word" title="Word" [width]="100">
              <ng-template kendoGridCellTemplate let-wordItem>
                <span (click)="gotoEditWordOfTheWeek(wordItem)">{{wordItem.word}}</span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="details" title="Details" [width]="400">
              <ng-template kendoGridCellTemplate let-wordItem>
                <span (click)="gotoEditWordOfTheWeek(wordItem)">{{HTMLdecode(wordItem.details)}}</span>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column [width]="50">
              <ng-template kendoGridCellTemplate let-wordItem>
                <button class="btn delete-btn" (click)="deleteWordOfTheWeek(wordItem.id)">
                  <span *ngIf="wordItem.details!='Awaiting Word of the Week'" class="delete fa-trash fa-solid fas item-icon fa-1x" ></span> Delete
                </button>
              </ng-template>
            </kendo-grid-column>
          </kendo-grid>
        </div>


      </div>
    </div>
  </div>
</div>

